module.exports = __webpack_public_path__ + "static/media/wave-campaigns-card.5edbb162.svg";